import { t } from "@i18n";
import { formatNumber } from "@ui/format";
import type { ReactNode } from "react";
import "./visualization.css";

export const valueText = (v: number | null | undefined) => (v == null ? t("visual.noMeasurement") : formatNumber(v, 3));
export function extent(values: number[]): [number, number] {
  return values.reduce<[number, number]>(([lo, hi], v) => [Math.min(lo, v), Math.max(hi, v)], [Infinity, -Infinity]);
}
export function ChartFrame({
  title,
  scope,
  children,
  className = "",
}: {
  title: string;
  scope: string;
  children: ReactNode;
  className?: string;
}) {
  return (
    <section className={`visual-frame ${className}`}>
      <h3 className="h2">{title}</h3>
      <p className="sm mu">{scope}</p>
      {children}
    </section>
  );
}
